import React from 'react';
import { View } from 'react-native';
// Custom
import { PnmacTextMobile } from '../Typography';
import PnmacSection from '../Section';
import PnmacUiButton from '../Uibutton/PnmacUibutton';
var NoDataAvailable = function (props) {
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacSection, {
    static: true,
    style: [s.section, props.topSectionStyle]
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    dark: true,
    size: 15,
    style: [s.text, props.topTextStyle]
  }, props.topText)), /*#__PURE__*/React.createElement(PnmacSection, {
    style: [props.bottomSectionStyle]
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    dark: true,
    size: 15,
    style: [s.text, props.bottomTextStyle]
  }, props.bottomText), /*#__PURE__*/React.createElement(PnmacUiButton, {
    asRow: true,
    onPress: props.onButtonPress,
    icon: 'arrow',
    text: props.buttonText
  })));
};
export default NoDataAvailable;
var s = {
  section: {
    marginTop: 40
  },
  text: {
    paddingVertical: 15,
    paddingHorizontal: 20
  }
};